// AboutPage.tsx
import React from "react";

const AboutPage: React.FC = () => {
  return (
    <div className="container px-5 pt-4">
      <div className="about-page">
        <h1>About Fan1</h1>

        <section className="about-section">
          <h3>Our Mission</h3>
          <p className="w-50 mx-auto">
            At Fan1, we are dedicated to bringing fans and celebrities closer
            together than ever before. Our platform provides an interactive
            space where celebrities can engage with their fans directly through
            live chats, exclusive content, and personalized experiences. We aim
            to empower both fans and celebrities to build stronger, more
            meaningful connections.
          </p>
        </section>

        <section className="about-section">
          <h3>What We Do</h3>
          <p className="w-50 mx-auto">
            Fan1 offers a unique platform for fans to interact with their
            favorite celebrities in real time. Whether it's attending virtual
            meet-and-greets, watching exclusive behind-the-scenes content, or
            participating in fan-driven events, we offer a one-of-a-kind
            experience for everyone involved.
          </p>
          <ul>
            <li>Real-time fan-celebrity interactions</li>
            <li>Exclusive live streams and events</li>
            <li>Fan-driven content creation and voting</li>
            <li>Celebrity-driven merchandise and content</li>
          </ul>
        </section>

        <section className="about-section">
          <h3>Our Vision</h3>
          <p className="w-50 mx-auto">
            We envision a future where fans and celebrities are no longer just
            distant figures but active collaborators in the creation of content
            and experiences. Fan1 strives to be the leading platform in bridging
            the gap between public figures and their audiences, making it easy
            for both to share, connect, and thrive together.
          </p>
        </section>

        <section className="about-section">
          <h3>Why Choose Fan1?</h3>
          <p className="w-50 mx-auto">
            Fan1 isn’t just a platform; it's a community. We’re committed to
            creating a safe, inclusive, and exciting space for fans and
            celebrities alike. Here are a few reasons why Fan1 is the ultimate
            choice:
          </p>
          <ul>
            <li>Engage with celebrities in real-time</li>
            <li>Access exclusive content and events</li>
            <li>Build a meaningful relationship with your favorite stars</li>
            <li>Support charitable causes alongside celebrities</li>
          </ul>
        </section>

        <section className="about-section">
          <h3>Our Team</h3>
          <p className="w-50 mx-auto">
            The team at Fan1 consists of passionate individuals who are experts
            in social media, entertainment, and technology. We’re dedicated to
            providing the best experience for both fans and celebrities, and
            we’re constantly innovating to make our platform better every day.
          </p>
        </section>

        <section className="about-section">
          <h3>Join Us</h3>
          <p className="w-50 mx-auto">
            Whether you're a fan looking to connect with your favorite
            celebrity, or a celebrity wanting to engage with your fanbase like
            never before, Fan1 is the place for you. Join us and be part of a
            revolutionary way to experience entertainment.
          </p>
        </section>
      </div>
    </div>
  );
};

export default AboutPage;
